export const SEBI_PILLARS = [
  "Governance & Cyber Strategy",
  "Risk Management",
  "Security Operations",
  "Identity & Access Management",
  "Data Security & Privacy",
  "Configuration & Change Management",
  "Vulnerability Assessment & Penetration Testing",
  "Incident & Crisis Management",
  "Third-Party Risk Management",
  "Cyber Resilience & Business Continuity",
  "Metrics, Assurance & Regulatory Reporting",
];
export const SEBI_CSCRF_CONTROLS = [
  {
    controlId: "CSCRF-GOV-01",
    pillar: "Governance & Cyber Strategy",
    objective: "Board oversight",
    requirement: "Board approve cyber policy, review risk quarterly",
    guidance: "Cyber Risk Committee; Board pack metrics",
    metrics: "Meeting frequency",
    evidence: "Board minutes",
    testMethod: "Board interview",
    frequency: "Quarterly",
    owner: "Board/CISO",
    observations: "No dedicated agenda",
    severity: "Critical",
    automation: "Low",
  },
  {
    controlId: "CSCRF-GOV-02",
    pillar: "Governance & Cyber Strategy",
    objective: "Cyber risk ownership",
    requirement: "Designated CISO with accountability",
    guidance: "CISO reporting to Board/CEO",
    metrics: "Reporting frequency",
    evidence: "CISO JD, Org chart",
    testMethod: "Org review",
    frequency: "Annual",
    owner: "MD",
    observations: "CISO reports to CTO",
    severity: "High",
    automation: "Low",
  },
  {
    controlId: "CSCRF-GOV-03",
    pillar: "Governance & Cyber Strategy",
    objective: "Cyber budget",
    requirement: "Dedicated security budget",
    guidance: "Min 10% of IT budget",
    metrics: "Budget allocation",
    evidence: "Budget documents",
    testMethod: "Budget review",
    frequency: "Annual",
    owner: "CFO/CISO",
    observations: "<5% budget",
    severity: "Medium",
    automation: "Low",
  },
  {
    controlId: "CSCRF-RISK-01",
    pillar: "Risk Management",
    objective: "Risk assessment",
    requirement: "Documented methodology",
    guidance: "NIST/ISO framework",
    metrics: "Coverage",
    evidence: "Risk report",
    testMethod: "Risk sample review",
    frequency: "Annual",
    owner: "Risk Manager",
    observations: "Ad-hoc assessment",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "CSCRF-SEC-01",
    pillar: "Security Operations",
    objective: "SIEM deployment",
    requirement: "Correlation rules for threats",
    guidance: "Insider, exfiltration use cases",
    metrics: "MTTD, MTTR",
    evidence: "SIEM architecture",
    testMethod: "SIEM review",
    frequency: "Continuous",
    owner: "SOC Manager",
    observations: "Limited use cases",
    severity: "Critical",
    automation: "High",
  },
  {
    controlId: "CSCRF-SEC-02",
    pillar: "Security Operations",
    objective: "SOC capability",
    requirement: "24x7 monitoring, playbooks",
    guidance: "L1/L2/L3 structure",
    metrics: "SOC coverage",
    evidence: "SOC org, Playbooks",
    testMethod: "SOC observation",
    frequency: "Continuous",
    owner: "SOC Manager",
    observations: "8x5 coverage",
    severity: "Critical",
    automation: "Medium",
  },
  {
    controlId: "CSCRF-IAM-01",
    pillar: "Identity & Access Management",
    objective: "Identity lifecycle",
    requirement: "Automated provisioning linked to HR",
    guidance: "HR-IAM integration",
    metrics: "Provisioning time",
    evidence: "IAM config",
    testMethod: "Joiner/Leaver test",
    frequency: "Continuous",
    owner: "IAM Lead",
    observations: "Manual process",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "CSCRF-IAM-02",
    pillar: "Identity & Access Management",
    objective: "PAM implementation",
    requirement: "Vaulting, session recording, JIT",
    guidance: "PAM for all admin",
    metrics: "PAM coverage",
    evidence: "PAM deployment",
    testMethod: "PAM review",
    frequency: "Continuous",
    owner: "IAM Lead",
    observations: "Limited scope",
    severity: "Critical",
    automation: "High",
  },
  {
    controlId: "CSCRF-DATA-01",
    pillar: "Data Security & Privacy",
    objective: "Data classification",
    requirement: "4-tier classification scheme",
    guidance: "Public to Restricted",
    metrics: "Coverage",
    evidence: "Classification policy",
    testMethod: "Data inventory",
    frequency: "Annual",
    owner: "Data Owner",
    observations: "No classification",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "CSCRF-DATA-02",
    pillar: "Data Security & Privacy",
    objective: "DLP controls",
    requirement: "Data at rest, motion, use",
    guidance: "PII, financial policies",
    metrics: "DLP incidents",
    evidence: "DLP configuration",
    testMethod: "DLP testing",
    frequency: "Continuous",
    owner: "Security Lead",
    observations: "Email only",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "CSCRF-VAPT-01",
    pillar: "Vulnerability Assessment & Penetration Testing",
    objective: "Vulnerability assessment",
    requirement: "Quarterly VA of critical systems",
    guidance: "Authenticated scans",
    metrics: "VA coverage",
    evidence: "VA reports",
    testMethod: "VA scope review",
    frequency: "Quarterly",
    owner: "Security Lead",
    observations: "Annual only",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "CSCRF-VAPT-02",
    pillar: "Vulnerability Assessment & Penetration Testing",
    objective: "Penetration testing",
    requirement: "Annual PT with social engineering",
    guidance: "External + internal",
    metrics: "PT coverage",
    evidence: "PT reports",
    testMethod: "PT scope review",
    frequency: "Annual",
    owner: "CISO",
    observations: "No social eng",
    severity: "High",
    automation: "Low",
  },
  {
    controlId: "CSCRF-INC-01",
    pillar: "Incident & Crisis Management",
    objective: "IRP capability",
    requirement: "Documented plan, roles, escalation",
    guidance: "NIST/SANS alignment",
    metrics: "MTTR",
    evidence: "IRP document",
    testMethod: "IRP walkthrough",
    frequency: "Quarterly",
    owner: "CISO",
    observations: "No documented IRP",
    severity: "Critical",
    automation: "Medium",
  },
  {
    controlId: "CSCRF-TPR-01",
    pillar: "Third-Party Risk Management",
    objective: "Vendor assessment",
    requirement: "Risk assessment for vendors",
    guidance: "Classification; Questionnaire",
    metrics: "Assessed %",
    evidence: "Vendor register",
    testMethod: "Vendor review",
    frequency: "Annual",
    owner: "Vendor Manager",
    observations: "No assessments",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "CSCRF-RES-01",
    pillar: "Cyber Resilience & Business Continuity",
    objective: "Resilience testing",
    requirement: "Annual test with DR, exercises",
    guidance: "Tabletop + technical",
    metrics: "RTO/RPO achievement",
    evidence: "Exercise reports",
    testMethod: "Exercise observation",
    frequency: "Annual",
    owner: "BCP Lead",
    observations: "Technical only",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "CSCRF-MET-01",
    pillar: "Metrics, Assurance & Regulatory Reporting",
    objective: "Security metrics",
    requirement: "KPIs/KRIs with Board reporting",
    guidance: "Min 15 metrics",
    metrics: "Metric coverage",
    evidence: "Metrics dashboard",
    testMethod: "Metrics review",
    frequency: "Monthly",
    owner: "CISO",
    observations: "<5 metrics",
    severity: "Medium",
    automation: "High",
  },
];

